import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TErrorCorrectionsStore,
	TErrorCorrectionsErrorTypesResponsePayload,
	TErrorCorrectionResponsePayload,
	TErrorCorrectionsScriptHistoryResponsePayload,
	TErrorCorrectionsScriptsResponsePayload,
	TErrorCorrectionsStartScriptResponsePayload,
	TErrorCorrectionsUserStatisticResponsePayload,
	TLaunchedScriptsResponsePayload,
} from './types';

export const getErrorCorrectionsState = (state: TStoreState): TErrorCorrectionsStore =>
	state.errorCorrections;

export const getErrorCorrections = createSelector(
	[getErrorCorrectionsState],
	(errorCorrections: TErrorCorrectionsStore) => errorCorrections,
);

// ==========================================:

export const getErrorTypes = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): TErrorCorrectionsErrorTypesResponsePayload =>
		errorCorrections.errorTypes,
);

// ==========================================:

export const getErrorTypesLoader = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): boolean => errorCorrections.errorTypesLoader,
);

// ==========================================:

export const getErrorCorrectionsLoader = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): boolean => errorCorrections.errorCorrectionsLoader,
);

// ==========================================:

export const getErrorCorrectionsList = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore) => errorCorrections.errorCorrections,
);

// ==========================================:

export const getErrorCorrectionLoader = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): boolean => errorCorrections.errorCorrectionLoader,
);

// ==========================================:

export const getErrorCorrection = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): TErrorCorrectionResponsePayload =>
		errorCorrections.errorCorrection,
);

// ==========================================:

export const getScriptHistoryLoader = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): boolean => errorCorrections.scriptsHistoryLoader,
);

// ==========================================:

export const getScriptHistory = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): TErrorCorrectionsScriptHistoryResponsePayload =>
		errorCorrections.scriptsHistory,
);

// ==========================================:

export const getScriptsLoader = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): boolean => errorCorrections.scriptsLoader,
);

// ==========================================:

export const getScripts = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): TErrorCorrectionsScriptsResponsePayload =>
		errorCorrections.scripts,
);

// ==========================================:

export const getStartScriptLoader = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): boolean => errorCorrections.startScriptLoader,
);

// ==========================================:

export const getStartScriptError = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): string | null => errorCorrections.startScriptError,
);

// ==========================================:

export const getUpdateParameterCounter = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): number => errorCorrections.parameterUpdateCounter,
);

// ==========================================:

export const getStartScriptResponse = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): TErrorCorrectionsStartScriptResponsePayload =>
		errorCorrections.startScriptResponse,
);

// ==========================================:

export const getStartScriptResponseArray = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): TErrorCorrectionsStartScriptResponsePayload[] =>
		errorCorrections.startScriptResponseArray,
);

// ==========================================:

export const getUserStatisticLoader = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): boolean => errorCorrections.userStatisticLoader,
);

// ==========================================:

export const getUserStatistic = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): TErrorCorrectionsUserStatisticResponsePayload =>
		errorCorrections.userStatistic,
);

// ==========================================:

export const getLaunchedScripts = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): TLaunchedScriptsResponsePayload =>
		errorCorrections.launchedScripts,
);

// ==========================================:

export const getLaunchedScriptsLoader = createSelector(
	[getErrorCorrections],
	(errorCorrections: TErrorCorrectionsStore): boolean => errorCorrections.launchedScriptsLoader,
);
